import { APIResponse } from '@/types';
import httpService from '../httpService';
import {
    PlanogramConfigResponse,
    PlanogramSettings,
    PlanogramSettingsResponse,
    PlanogramTableParams,
    PlanogramTableResponse,
    ProductData,
} from '@/types/pages/storeManagement/shelfPlanogram';

export const fetchPlanogramConfig = (storeId: number): APIResponse<PlanogramConfigResponse> => {
    return httpService.get('/planogram/rack_config', {
        params: {
            store_id: storeId,
        },
    });
};

export const fetchPlanogramTable = (params: PlanogramTableParams): APIResponse<PlanogramTableResponse> => {
    return httpService.post('/planogram/rack_summary', params);
};

export const updateStoreSetting = (
    storeId: number,
    params: PlanogramSettings,
): APIResponse<PlanogramSettingsResponse> => {
    return httpService.post(`/store/${storeId}/setting`, params);
};

export const fetchProductInfoAPI = (storeId: number, keyword: string[]): APIResponse<ProductData> => {
    return httpService.get(`/bond/information`, {
        params: {
            store_id: storeId,
            keyword: keyword,
            scope: 'product',
        },
    });
};
